// core version + navigation, pagination modules:
import Swiper, {
  Navigation,
  Pagination,
  Scrollbar,
  Thumbs,
  Autoplay,
} from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, Thumbs, Autoplay]);

const defaultSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 5,
  centeredSlides: true,
  loop: true,
  autoplay: true,
  breakpoints: {
    1300: {
      slidesPerView: 4,
      centeredSlides: false,
      loop: false,
      spaceBetween: 15,
    },
    1170: {
      slidesPerView: 4,
      centeredSlides: false,
      loop: false,
      spaceBetween: 15,
    },
    992: {
      slidesPerView: 3,
      centeredSlides: false,
      loop: false,
      spaceBetween: 15,
    },
    600: {
      slidesPerView: 2,
    },
    310: {
      slidesPerView: 2,
    },
    300: {
      slidesPerView: 1,
    },
  },
};

const defaultSliders = document.querySelectorAll(".appSlider-js");
if (defaultSliders) {
  defaultSliders.forEach((slider) => {
    if (slider.classList.contains("is-5")) {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
          delay: 2000,
        },
        breakpoints: {
          1300: {
            slidesPerView: 3,
          },
          1170: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 2,
          },
          600: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1,
          },
          300: {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
      });
    } else if (slider.classList.contains("is-work")) {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          1170: {
            slidesPerView: 4,
          },
          400: {
            slidesPerView: 2,
          },
          300: {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
      });
    } else if (slider.classList.contains("is-team")) {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          1400: {
            slidesPerView: 6,
            spaceBetween: 15,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 5,
          },
          300: {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
      });
    } else if (slider.classList.contains("is-reviews")) {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          1400: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 2,
          },
          800: {
            slidesPerView: 2,
          },
          300: {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
      });
    } else if (slider.classList.contains("is-1")) {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 2000,
        },
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
      });
    } else {
      new Swiper(slider, {
        ...defaultSliderOptions,
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
      });
    }
  });
}
